<template>
    <div class="user-agreement-page">
        <webf-listview class="main">
            <p class="title">齐思用户服务协议</p>
            <p class="date">更新日期：2022 年 6 月 9 日</p>
            <p class="date">生效日期：2022 年 1 月 8 日</p>
            <p class="header1">1. 特别提示</p>
            <p class="header2">1.1
                欢迎您使用齐思（以下简称“本平台”）的产品与服务（以下简称“齐思服务”）。本平台的运营者及齐思服务的提供者均为梦溪创坛（北京）创新科技有限公司。各条款标题仅为帮助您理解该条款表达的主旨之用，不影响或限制本协议条款的含义或解释。为维护您的自身权益，建议您仔细阅读各条款具体表述。
            </p>
            <p class="header2">1.2
                《齐思隐私政策》以及本平台公布的其他协议规范、规则、声明、公告、政策等（以下统称“齐思的其他规则”）是本协议不可分割的组成部分，您在使用齐思服务时应同样遵守。您接受并同意本协议的行为即视为您同意并接受齐思的其他规则，您接受并同意任一齐思的其他规则的行为亦视为您接受并同意本协议。
            </p>
            <p class="header2">1.3
                您在申请注册流程中或在本协议更新时点击同意本协议之前，应当认真阅读本协议。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。免除或者限制责任的条款，您应重点阅读。
            </p>
            <p class="header2">1.4
                当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后或在本协议更新时点击同意，即表示您已充分阅读、理解并接受本协议的全部内容。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您将无法正常使用齐思并影响您使用齐思的部分功能。
            </p>
            <p class="header1">2. 服务内容</p>
            <p class="header2">2.1
                齐思服务的具体内容由本平台根据实际情况提供，包括但不限于授权您通过其账号，使用齐思服务提问、回答、分享、评论以及关注内容和其他用户，本平台有权对齐思服务或产品形态进行升级或其他调整，并将及时更新页面/告知。
            </p>
            <p class="header2">2.2
                您理解，本平台仅提供与齐思服务相关的技术服务，除此之外与相关网络服务有关的设备（如个人电脑、手机、及其他与接入互联网或移动互联网有关的装置）及所需的费用（如为接入互联网而支付的电话费及上网费、为使用移动网而支付的手机费）均应由您自行负担。
            </p>
            <p class="header1">3. 服务变更、中断或终止</p>
            <p class="header2">3.1
                鉴于网络服务的特殊性（包括但不限于服务器的稳定性问题、恶意的网络攻击等行为的存在及其他本平台无法控制的情形），用户同意本平台有权随时中断或终止部分或全部的齐思服务，若发生该等中断或中止奇迹社区服务的情形，本平台将尽可能及时通过网页公告、系统通知、私信、短信提醒或其他合理方式通知受到影响的用户。
            </p>
            <p class="header2">3.2
                您理解，本平台需要定期或不定期地对提供齐思服务的平台（如互联网网站、移动网络等）或相关的设备进行检修或者维护，如因此类情况而造成服务在合理时间内的中断，本平台无需为此承担任何责任，但本平台应尽可能事先进行通告。
            </p>
            <p class="header2">3.3 如发生下列任何一种情形，本平台可能随时中断或终止向您提供本协议项下的齐思服务：</p>
            <p class="header3">1) 您提供的个人资料不真实；</p>
            <p class="header3">2) 您违反法律法规、国家政策或本协议及本平台公示的各项规则、规范。</p>
            <p class="header2">3.4 如您在申请开通齐思服务后在任何连续365日内未实际使用，则本平台有权选择采取以下任何一种方式进行处理：</p>
            <p class="header3">1) 回收并注销您的昵称、账号；</p>
            <p class="header3">2) 停止为您提供齐思服务。</p>
            <p class="header2">3.5
                若您选择将齐思账号与本平台合作的第三方账号进行绑定的，除您自行解除绑定关系外，发生下列任何一种情形，您已绑定的第三方账号也有可能被解除绑定而本平台无需对您或任何第三方承担任何责任：</p>
            <p class="header3">1) 您违反法律法规国家政策或本协议的;</p>
            <p class="header3">2) 您违反第三方账号服务商的用户协议或其相关规定的;</p>
            <p class="header3">3) 发生其他本平台认为需要解除绑定的情形。</p>
            <p class="header1">4. 使用规则</p>
            <p class="header2">4.1
                注册齐思账号制作、发布、传播信息内容的，应当使用真实身份信息及个人资料，不得以虚假、冒用的居民身份信息、企业注册信息、组织机构代码信息进行注册；若用户的个人资料有任何变动，用户应及时更新。</p>
            <p class="header2">4.2
                您可自行编辑注册信息中的账号名称、头像、简介等，但应遵守法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性等“七条底线”以及相关管理规定，不得含有违法和不良信息。</p>
            <p class="header2">4.3
                如您违反前述约定，依据相关法律、法规及国家政策要求，本平台有权随时采取不予注册、通知限期改正、注销登记用户账号、中止或终止用户对齐思服务的使用等措施。如您冒用其他自然人或组织的姓名或名称注册账号，本平台有权注销该用户账号，并向互联网信息内容主管部门报告。
            </p>
            <p class="header2">4.4 本平台将建立健全用户信息安全管理制度、落实技术安全防控措施。本平台将对用户使用齐思服务过程中涉及的用户隐私内容加以保护。</p>
            <p class="header2">4.5
                由于齐思服务的存在前提是您在申请开通齐思服务的过程中所提供的账号，因此您不应将账号、密码转让或出借予他人使用。如您发现账号或齐思服务遭他人非法使用，应立即通知本平台。因黑客行为或用户的保管疏忽导致账号、密码及齐思服务遭他人非法使用，本平台不对非因本平台原因造成的损失承担责任。
            </p>
            <p class="header2">4.6 您在使用齐思服务的过程中应文明发言，并依法尊重其它用户的人格权与身份权等人身权利，共同建立和谐、文明、礼貌的网络社交环境。</p>
            <p class="header2">4.7 您在使用齐思服务过程中，必须遵循以下原则：</p>
            <p class="header3">1) 不得违反中华人民共和国法律法规及相关国际条约或规则；</p>
            <p class="header3">2) 不得违反与网络服务、齐思服务有关的网络协议、规定、程序及行业规则；</p>
            <p class="header3">3) 不得违反法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性等“七条底线”要求；</p>
            <p class="header3">4) 不得进行任何可能对互联网或移动网正常运转造成不利影响的行为；</p>
            <p class="header3">5)
                不得上传、展示或传播任何不实的、虚假的、冒充性的、骚扰性的、中伤性的、攻击性的、辱骂性的、恐吓性的、种族歧视性的、诽谤诋毁的、泄露隐私的、涉及成人情色的、恶意抄袭的或其他任何非法的信息资料；</p>
            <p class="header3">6) 不得发布破坏国家宗教政策，宣扬邪教和封建迷信等内容；</p>
            <p class="header3">7) 不得以任何方式侵犯其他任何人依法享有的专利权、著作权、商标权等知识产权，或姓名权、名称权、名誉权、荣誉权、肖像权、隐私权等人身权益，或其他任何合法权益；
            </p>
            <p class="header3">8) 不得发布齐思基于社区和用户利益，认为不适合在齐思展示的内容；</p>
            <p class="header3">9) 不得干扰或破坏本服务或与本服务相连线之服务器和网络，或违反任何关于本服务连线网络之规定、程序、政策或规范；</p>
            <p class="header3">10) 不得为其他任何非法目的而使用齐思服务。</p>
            <p class="header2">4.8
                如您在使用齐思服务的过程中遇到其它用户上传违法侵权等内容，可联系本平台工作人员或发送邮件至community@miracleplus.com进行投诉反馈，本平台会尽快核实并按照相应法律法规进行处理；如您认为上述方法无法解决遇到的问题，或您觉得有必要向司法行政机关寻求帮助的，本平台将依法配合司法机关的调查取证工作。
            </p>
            <p class="header2">4.9 您知悉、理解并同意授权本平台可非独家、可转授权地使用您通过使用齐思服务发布的内容，前述内容包括但不限于文字、图片、视频等。具体来说，可能会包括：</p>
            <p class="header3">1)
                将前述内容通过本平台自身或其他第三方在本平台选择的网络平台、应用程序或产品中，以有线或无线网，通过免费或收费的方式在不同终端（包括但不限于电脑、手机、互联网电视、机顶盒及其他上网设备等）以不同形式进行网络传播或电信增值服务等；
            </p>
            <p class="header3">2) 将前述内容复制、翻译、编入本平台当前已知或以后开发的作品、媒体或技术中，用于提供齐思服务相关的开发或推广宣传工作等；</p>
            <p class="header3">3) 将前述内容授权给电台、电视台、网络媒体、运营商平台等与本平台有合作的媒体或运营商播放、传播，用于齐思平台相关的推广宣传等；</p>
            <p class="header3">4) 其他本平台出于善意或另行取得用户授权的使用行为；</p>
            <p class="header3">5) 用户对本平台的前述授权并不改变用户发布内容的所有权及知识产权归属，也并不影响用户行使其对发布内容的合法权利；</p>
            <p class="header3">6) 本平台将尽最大的商业努力合理使用用户的授权内容，但并不代表本平台承诺一定会使用。</p>
            <p class="header2">4.10
                本平台有权对您使用齐思服务的行为及信息进行审查、监督及处理，包括但不限于用户信息（账号信息、个人信息等）、发布内容（位置、文字、图片、音频、视频、商标、专利、出版物等）、用户行为（关注、点赞、评论、举报投诉等）等范畴。如本平台发现、或收到第三方向本平台举报或投诉您在使用齐思服务时违反本协议第4条使用规则相关规定，本平台或其授权的主体有权依据其合理判断要求用户：
            </p>
            <p class="header3">1) 限期改正；</p>
            <p class="header3">2)
                不经通知直接采取一切必要措施以减轻或消除用户不当行为造成的影响，并将尽可能在处理之后对用户进行通知。上述必要措施包括但不限于更改、屏蔽或删除相关内容，警告违规账号，限制或禁止违规账号部分或全部功能，暂停、终止、注销用户使用齐思服务的权利等。
            </p>
            <p class="header1">5. 广告</p>
            <p class="header2">5.1
                您理解并同意，在使用齐思服务过程中本平台可能会向您推送具有相关性的信息、广告发布或品牌推广服务，或在本平台展示齐思相关和/或第三方供应商、合作伙伴的商业广告、推广或信息（包括商业或非商业信息）。</p>
            <p class="header2">5.2 在使用齐思服务过程中，本平台可能会通过电子邮件或其他方式向您发送的商品促销或其他相关商业信息，您可以选择退订我们发送给你的营销信息。</p>
            <p class="header2">5.3
                本平台依照法律规定履行广告及推广相关义务，您应当自行判断该广告或推广信息的真实性和可靠性并为自己的判断行为负责。除法律法规明确规定外，您因该广告或推广信息进行的购买、交易或因前述内容遭受的损害或损失将由您自行承担，非因本平台原因造成的损失本平台不予承担责任。
            </p>
            <p class="header1">6. 知识产权</p>
            <p class="header2">6.1
                在本平台及齐思服务中所提供的内容（包括但不限于软件、技术、程序、网页、文字、图片、图像、音频、视频、图表、版面设计、电子文档等）的知识产权属于本平台或原始著作权人所有。本平台提供齐思服务时所依托的软件的著作权、专利权及其他知识产权均归本平台所有。未经本平台或原始著作权人许可，任何人不得擅自使用（包括但不限于通过任何机器人、蜘蛛等程序或设备监视、复制、传播、展示、镜像、上载、下载）齐思服务中的内容。
            </p>
            <p class="header2">6.2
                您理解并同意，在使用齐思服务时发布上传的文字、图片、视频、音频等均由您原创或已获得合法授权。您通过本平台上传、发布的任何内容的知识产权归属您或原始著作权人所有。</p>
            <p class="header2">6.3
                您在使用齐思服务的过程中，可能会使用到由第三方针对齐思服务开发的在齐思平台运行的软件或提供的服务，您除遵守本协议相关规定以外，还应遵守该等第三方的相关规定，并尊重第三方权利人对其软件、服务及其所包含内容的相关权利。
            </p>
            <p class="header2">6.4 鉴于以上，您理解并同意：</p>
            <p class="header3">1) 未经本平台及相关权利人同意，您不得对上述功能、软件、服务进行反向工程 （reverse
                engineer）、反向编译（decompile）或反汇编（disassemble）等；同时，不得将上述内容或资料在任何媒体直接或间接发布、播放、出于播放或发布目的而改写或再发行，或者用于其他任何目的；
            </p>
            <p class="header3">2)
                在尽商业上的合理努力的前提下，本平台并不就上述功能、软件、服务及其所包含内容的延误、不准确、错误、遗漏或由此产生的任何损害，以任何形式向用户或任何第三方承担任何责任。</p>
            <p class="header1">7. 法律适用和争议解决</p>
            <p class="header2">7.1 本协议的订立、效力、解释、履行和争议的解决应受中国法律的管辖，并依其解释。</p>
            <p class="header2">7.2
                在本协议执行过程中，若出现与本协议有关的争议，双方应通过友好协商解决；若任何争议无法在争议发生后十五天内通过协商解决，则任何一方有权向本平台所在地人民法院提起诉讼。</p>
            <p class="header2">7.3 在诉讼期间，除有争议的事项外，本协议应继续执行。</p>
            <p class="header1">8. 违约责任</p>
            <p class="header2">
                本协议任何一方违反或没有履行其在本协议中的陈述、保证、义务或责任，即构成违约。守约方有权以书面形式通知违约方要求对违约行为进行补救。若违约方在收到上述书面通知后的十日内未采取及时、充分的补救措施，守约方有权就其因违约行为所受的损失要求违约方进行赔偿。
            </p>
            <p class="header1">9. 附则</p>
            <p class="header2">9.1
                本平台有权在向用户发出书面通知的前提下，将其在本协议下的全部或部分权利与义务转让给其关联方继续享有或履行。但除非取得本平台的书面同意，用户不得将其在本协议项下的全部或部分权利与义务转让给任何第三方。</p>
            <p class="header2">9.2 本协议部分条款无效、被撤销或者终止的，不影响其他条款的效力，其他条款仍然有效。</p>
        </webf-listview>
    </div>
</template>
<style lang="css" scoped>
.user-agreement-page {
    padding: 16px;
    background-color: var(--background-color);
    .main {
        height: 100vh;
        color: var(--font-color);
    }
}
</style>
